import { useCallback, useRef, useState } from 'react'

export type CoinReward = { id: number; amount: number }

/** Keep consecutive rewards intact while the previous coins are still travelling. */
export function useCoinRewards() {
  const nextId = useRef(0)
  const [queue, setQueue] = useState<CoinReward[]>([])
  const celebrate = useCallback((amount: number) => {
    if (!Number.isFinite(amount) || amount <= 0) return
    const reward = { id: ++nextId.current, amount }
    setQueue((current) => [...current, reward])
  }, [])
  const complete = useCallback((id: number) => {
    setQueue((current) => current.filter((reward) => reward.id !== id))
  }, [])
  return { reward: queue[0] ?? null, celebrate, complete }
}
